import LogRocket from "logrocket";

if (process.env.GATSBY_ENV === "production") {
  console.debug("Initializing LogRocket");
  LogRocket.init("ksptao/modemagic");
}
